import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App.tsx'
import { ContextStateProvider } from "./context/index.ts";

createRoot(document.querySelector('body > .main-wrapper')!).render(
    <StrictMode>
        <ContextStateProvider>
            <App />
        </ContextStateProvider>
     </StrictMode>,
)
